import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { useModalHandle, InstantBookingModal } from '@spotahome/ui-library';

const InstantBookingLabelDescription = ({ rules }) => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle({
    removeScrollbarCSL: true
  });

  const handleOnClick = e => {
    e.preventDefault();
    handleModalOpen();
  };

  return (
    <>
      <div
        role="button"
        tabIndex={-1}
        onClick={handleOnClick}
        dangerouslySetInnerHTML={{
          __html: trans('listing.labels.instantBooking.description')
        }}
      />
      <InstantBookingModal
        isOpen={isModalOpen}
        handleModalClose={handleModalClose}
        rules={rules}
      />
    </>
  );
};

InstantBookingLabelDescription.propTypes = {
  rules: PropTypes.node.isRequired
};

export default InstantBookingLabelDescription;
